export default __webpack_public_path__ + "react/assets/png/download-app-ios.png";